module.exports = __webpack_public_path__ + "static/media/addcomment.c00acd61.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Signup/Media/addcomment.PNG
// module id = 78
// module chunks = 0